<div>
    <router-outlet></router-outlet>
</div>
<!--Notification Content-->
<bh-notifications></bh-notifications>